import React from 'react';
import { BookOpenIcon, ShieldCheckIcon } from 'lucide-react';
import { mockupUrl, offerAnchor, productName } from '../data/content';
import { Button } from './ui/Button';
import { OfferLink } from './ui/OfferLink';
export function Hero() {
  return <section className="bg-brand pb-14 md:pb-16" data-id="element-91" data-mp="9l375k8q6q7o">
      <div className="border-b border-white/10 px-4 py-2.5 text-center" data-id="element-92" data-mp="4mi2n8mfxkdf">
        <p className="text-[11px] font-extrabold uppercase tracking-[.3em] text-gold-light md:text-xs" data-id="element-93" data-mp="129h19owp12dy">
          Bright Digital Hub
        </p>
      </div>
      <div className="mx-auto max-w-4xl px-4 pt-8 text-center md:pt-10" data-id="element-94" data-mp="xaxghrtu5wn6">
        <h1 className="mx-auto max-w-3xl font-black uppercase leading-tight tracking-tight text-white" data-id="element-95" data-mp="sai3x2hdot69">
          <span className="block text-xs text-white/85 md:text-sm" data-id="element-96" data-mp="nb6l7nxgbdm1">
            The complete ready-to-use myofascial release and clinical rehabilitation system for professionals
          </span>
          <span className="mt-2 block text-2xl sm:text-3xl md:text-4xl" data-id="element-97" data-mp="3825w6klg5xiq">
            Complete Professional <span className="text-gold-light" data-id="element-98" data-mp="3j897lcz58bpj">Myofascial Release</span> Bundle
          </span>
        </h1>

        <OfferLink className="mx-auto my-7 max-w-[300px] sm:max-w-[400px]" label={`See the ${productName} offer`} data-id="element-99" data-mp="3o6ki7px9iq8t">
          <img src={mockupUrl} alt={`${productName}: 5 complete volumes and 5 practical bonuses`} className="w-full object-contain drop-shadow-2xl transition-transform duration-300 ease-out group-hover:scale-[1.015]" data-id="element-100" data-mp="399tex5kgwudx" />
        </OfferLink>

        <p className="mx-auto max-w-2xl text-base font-black leading-relaxed text-white md:text-lg" data-id="element-101" data-mp="359syjfdt6948">
          5 complete volumes + 5 practical bonuses
        </p>
        <p className="mx-auto mt-3 max-w-2xl text-sm leading-relaxed text-white/85 md:text-base" data-id="element-102" data-mp="2violwmblv0ck">
          <strong className="text-white" data-id="element-103" data-mp="2hjf79r31seap">60 soft-tissue techniques</strong> and{' '}
          <strong className="text-white" data-id="element-104" data-mp="2hlja05p7n79e">40 clinical session templates</strong> across five body regions — with patient
          positioning, hand placement, functional exercises, and ready-to-adapt sessions.
        </p>
        <p className="mt-5 text-xs font-black uppercase tracking-wider text-white md:text-sm" data-id="element-105" data-mp="nbl1chqpya8v">
          Less time searching. <span className="text-gold-light" data-id="element-106" data-mp="ibgod1p0rxne">More clarity in every session.</span>
        </p>

        <div className="mt-7" data-id="element-107" data-mp="ddwwgyzefmcz">
          <Button href={offerAnchor} size="lg" subtext="Get instant digital access today" data-id="element-108" data-mp="deq6q9xkgtzv">
            Yes! I want the complete system
          </Button>
        </div>

        <ul className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-[11px] font-bold uppercase tracking-wide text-white/85" data-id="element-109" data-mp="161jal16969e3">
          <li className="flex items-center gap-1.5" data-id="element-110" data-mp="110wnployxk28">
            <ShieldCheckIcon className="h-4 w-4 text-gold-light" aria-hidden="true" data-id="element-111" data-mp="x1nwoolbc0ad" /> 7-Day Guarantee
          </li>
          <li className="flex items-center gap-1.5" data-id="element-112" data-mp="3lu0454qihb1b">
            <BookOpenIcon className="h-4 w-4 text-gold-light" aria-hidden="true" data-id="element-113" data-mp="3lqm4435bldx1" /> Instant Digital Access
          </li>
        </ul>
      </div>
    </section>;
}